import Proxy from '../Proxy';

class CleanerProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('cleaners', parameters);
  }

  schedules() {
    return this.submit('get', `${this.endpoint}/schedules`);
  }

  availibility(data={}) {
    return this.submit('post', `${this.endpoint}/available/days`, data);
  }

  checkLists() {
    return this.submit('get', `${this.endpoint}/checklists`);
  }

  updateAvailibility(data) {
    return this.submit('put', `${this.endpoint}/available/days`, data);
  }

  updateSchedules(id, data) {
    return this.submit('put', `${this.endpoint}/schedule/${id}`, data);
  }

  available() {
    return this.submit('get', `${this.endpoint}/available`);
  }

  updateItems(type, data) {
    return this.submit('put', `${this.endpoint}/checklists/items/${type}`, data);
  }

  addItem(type, data) {
    return this.submit('post', `${this.endpoint}/checklists/items/${type}`, data);
  }

  deleteItem(type, id) {
    return this.submit('delete', `${this.endpoint}/checklists/items/${type}/${id}`);
  }

  updateChecklistMap(type, data) {
    return this.submit('put', `${this.endpoint}/checklists/order-types/${type}`, data);
  }
}

export default CleanerProxy;
